import { commonIcon } from "../../asset";
import { useSelector, useDispatch } from "react-redux";
import { chatAction } from "../../store/chat";
import { CHAT_TYPE, ROLE, SEARCH_TYPE_OPTIONS } from "../../constants/index";
import { toast } from "react-toastify";

import { updateProfile } from "../../store/user-action";
import { uiAction } from "../../store/ui-gemini";

const ChatType = () => {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.user.isLogin)
  const isAdvanceGeminiPrompt = useSelector((state) => state.ui.isAdvanceShow);
  const chatType = useSelector((state) => state.chat.chatType);
  const userDetails = useSelector((state) => state.user.user);

  const setChatType = async (type) => {
    try {
      console.log("=== CHAT TYPE SELECTION ===");
      console.log("Selected type:", type);
      console.log("Is login:", isLogin);

      if (type !== chatType) {
        dispatch(chatAction.chatHistoryIdHandler({ chatHistoryId: "" }));
        dispatch(chatAction.replacePreviousChat({ previousChat: [] }));
      }

      dispatch(chatAction.setChatType(type));
      dispatch(uiAction.toggleAdvanceShow());

      if (isLogin) {
        console.log("Updating profile with type:", type);
        await updateProfile({ type: type });
        console.log("Profile updated successfully");
      }
      console.log("=== END CHAT TYPE SELECTION ===");
    } catch (error) {
      console.error("Error updating chat type:", error);
      toast.error(error?.response?.data?.message);
    }
  };

  if (!isAdvanceGeminiPrompt) {
    return <></>;
  }

  // Debug: Check admin role
  console.log("ChatType - isLogin:", isLogin);
  console.log("ChatType - userDetails:", userDetails);
  console.log("ChatType - userDetails?.role:", userDetails?.role);
  console.log("ChatType - ROLE.ADMIN:", ROLE.ADMIN);
  console.log("ChatType - isAdmin:", userDetails?.role === ROLE.ADMIN);

  return (
    <div className="z-[50]">
      <div
        className="absolute z-[51] inset-0 bg-black/40"
        onClick={() => dispatch(uiAction.toggleAdvanceShow())}
      />
      <div className="absolute left-4 top-16 z-[51] w-[300px] p-2 rounded-lg shadow flex flex-col items-center gap-2 bg-gray-100">
        <p className="capitalize font-semibold self-start text-gray-500">
          Select Type
        </p>

        <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
          <div className="inline-flex items-center justify-center gap-2 relative z-10">
            <img
              src={commonIcon.chatGeminiIcon}
              className="size-6"
              alt="Gospel Truth"
            ></img>

            <p className="flex active items-center gap-1 font-semibold inset-0 w-full absolute left-8 -translate-y-[130px] group-has-[:checked]:opacity-100  group-has-[:checked]:translate-y-0  whitespace-nowrap transition-all duration-700 opacity-0">
              <span className="text-[#231F20]">Gospel</span>
              <span className="text-[#7B7C7F]">Truth</span>
              Private
            </p>
            <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:translate-y-[130%] whitespace-nowrap transition-all duration-700 opacity-40">
              <span className="text-[#231F20]">Gospel</span>
              <span className="text-[#7B7C7F]">Truth</span>
              Private
            </p>
          </div>
          <input
            className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
            checked={chatType === CHAT_TYPE.PRIVATE}
            onChange={(e) => setChatType(CHAT_TYPE.PRIVATE)}
            name="chattype"
            type="radio"
          />
        </label>
        <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
          <div className="inline-flex items-center justify-center gap-2 relative z-10">
            <img
              src={commonIcon.chatGeminiIcon}
              className="size-6"
              alt="Gospel Truth"
            ></img>

            <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
              <span className="text-[#231F20]">Gospel</span>
              <span className="text-[#7B7C7F]">Truth</span>
              Public
            </p>
          </div>
          <input
            className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
            checked={chatType === CHAT_TYPE.PUBLIC}
            onChange={() => setChatType(CHAT_TYPE.PUBLIC)}
            name="chattype"
            type="radio"
          />
        </label>
        {SEARCH_TYPE_OPTIONS.filter((option) => option.id === CHAT_TYPE.PRIVATE_V2).map(
          (option) => (
            <label
              key={option.id}
              className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden"
            >
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">{option.gospel}</span>
                  <span className="text-[#7B7C7F]">{option.truth}</span>
                  {option.suffix}
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === option.id}
                onChange={() => setChatType(option.id)}
                name="chattype"
                type="radio"
              />
            </label>
          )
        )}
        {userDetails?.role === ROLE.ADMIN && (
          <>
            <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">Truth</span>
                  Private V3.2
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.PRIVATE_V3_2}
                onChange={(e) => setChatType(CHAT_TYPE.PRIVATE_V3_2)}
                name="chattype"
                type="radio"
              />
            </label>

            {/* <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">Truth</span>
                  Public V3.2
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.PUBLIC_V3_2}
                onChange={(e) => setChatType(CHAT_TYPE.PUBLIC_V3_2)}
                name="chattype"
                type="radio"
              />
            </label> */}

            <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">Truth</span>
                  Private O3
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.PRIVATE_O3}
                onChange={(e) => setChatType(CHAT_TYPE.PRIVATE_O3)}
                name="chattype"
                type="radio"
              />
            </label>

            <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">Truth</span>
                  Public O3
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.PUBLIC_O3}
                onChange={(e) => setChatType(CHAT_TYPE.PUBLIC_O3)}
                name="chattype"
                type="radio"
              />
            </label>
            <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">GPT</span>
                  Public
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.GPT_PUBLIC}
                onChange={(e) => setChatType(CHAT_TYPE.GPT_PUBLIC)}
                name="chattype"
                type="radio"
              />
            </label>
            <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
              <div className="inline-flex items-center justify-center gap-2 relative z-10">
                <img
                  src={commonIcon.chatGeminiIcon}
                  className="size-6"
                  alt="Gospel Truth"
                ></img>

                <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                  <span className="text-[#231F20]">Gospel</span>
                  <span className="text-[#7B7C7F]">GPT</span>
                  Private
                </p>
              </div>
              <input
                className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                checked={chatType === CHAT_TYPE.GPT_PRIVATE}
                onChange={(e) => setChatType(CHAT_TYPE.GPT_PRIVATE)}
                name="chattype"
                type="radio"
              />
            </label>

            {userDetails?.role === ROLE.ADMIN && (
              <>
                <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
                  <div className="inline-flex items-center justify-center gap-2 relative z-10">
                    <img
                      src={commonIcon.chatGeminiIcon}
                      className="size-6"
                      alt="Gospel Truth"
                    ></img>

                    <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                      <span className="text-[#231F20]">Gospel</span>
                      <span className="text-[#7B7C7F]">Truth</span>
                      Public Gemini
                    </p>
                  </div>
                  <input
                    className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                    checked={chatType === CHAT_TYPE.GEMINI_BETA_PUBLIC}
                    onChange={(e) => setChatType(CHAT_TYPE.GEMINI_BETA_PUBLIC)}
                    name="chattype"
                    type="radio"
                  />
                </label>

                <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
                  <div className="inline-flex items-center justify-center gap-2 relative z-10">
                    <img
                      src={commonIcon.chatGeminiIcon}
                      className="size-6"
                      alt="DeepSeek"
                    ></img>

                    <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                      <span className="text-[#231F20]">DeepSeek</span>
                      <span className="text-[#7B7C7F]">v3</span>
                      Public
                    </p>
                  </div>
                  <input
                    className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                    checked={chatType === CHAT_TYPE.DEEPSEEK_V3_PUBLIC}
                    onChange={(e) => setChatType(CHAT_TYPE.DEEPSEEK_V3_PUBLIC)}
                    name="chattype"
                    type="radio"
                  />
                </label>

                <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
                  <div className="inline-flex items-center justify-center gap-2 relative z-10">
                    <img
                      src={commonIcon.chatGeminiIcon}
                      className="size-6"
                      alt="DeepSeek"
                    ></img>

                    <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                      <span className="text-[#231F20]">DeepSeek</span>
                      <span className="text-[#7B7C7F]">v3</span>
                      Private
                    </p>
                  </div>
                  <input
                    className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                    checked={chatType === CHAT_TYPE.DEEPSEEK_V3_PRIVATE}
                    onChange={(e) => setChatType(CHAT_TYPE.DEEPSEEK_V3_PRIVATE)}
                    name="chattype"
                    type="radio"
                  />
                </label>

              </>
            )}
            {userDetails.role === ROLE.ADMIN && (
              <label className="group inline-flex justify-between w-full items-center z-10 rounded-lg p-3 border border-transparent has-[:checked]:border-indigo-500 has-[:checked]:text-indigo-900 has-[:checked]:bg-indigo-50 has-[:checked]:font-bold hover:bg-slate-200 transition-all cursor-pointer has-[:checked]:transition-all has-[:checked]:duration-500 duration-500 relative [&_p]:has-[:checked]:translate-x-0 [&_p]:has-[:checked]:transition-transform [&_p]:has-[:checked]:duration-500 overflow-hidden">
                <div className="inline-flex items-center justify-center gap-2 relative z-10">
                  <img
                    src={commonIcon.chatGeminiIcon}
                    className="size-6"
                    alt="Elastik POC"
                  ></img>

                  <p className="flex items-center gap-1 font-semibold inset-0 w-full absolute left-8 translate-y-0 group-has-[:checked]:opacity-100 whitespace-nowrap transition-all duration-700 opacity-40">
                    <span className="text-[#231F20]">Elastik</span>
                    <span className="text-[#7B7C7F]">POC</span>
                    Private
                  </p>
                </div>
                <input
                  className="checked:text-indigo-500 checked:ring-0 checked:ring-current focus:ring-0 focus:ring-current cursor-pointer"
                  checked={chatType === CHAT_TYPE.ELASTIK_POC}
                  onChange={(e) => setChatType(CHAT_TYPE.ELASTIK_POC)}
                  name="chattype"
                  type="radio"
                />
              </label>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChatType;
